import { render, staticRenderFns } from "./ArrobaMedellinArrobitaNoData.html?vue&type=template&id=037d15f4&scoped=true&"
import script from "./ArrobaMedellinArrobitaNoData.vue?vue&type=script&lang=js&"
export * from "./ArrobaMedellinArrobitaNoData.vue?vue&type=script&lang=js&"
import style0 from "./ArrobaMedellinArrobitaNoData.scss?vue&type=style&index=0&id=037d15f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d15f4",
  null
  
)

export default component.exports